export default "__VITE_ASSET__B8zrP3NJ__"